import React from "react";

const DataUPAS = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data Transjakarta"
        src="https://datastudio.google.com/embed/reporting/a4a9fa63-5760-431c-ae03-71371977e909/page/6cW5F"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default DataUPAS;
